// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PExclamationCircleOutlinedSvg from "@fishx/icons-svg/es/asn/PExclamationCircleOutlined";
import FishxIcon from '../components/FishxIcon';

var PExclamationCircleOutlined = function PExclamationCircleOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PExclamationCircleOutlinedSvg
  }));
};

PExclamationCircleOutlined.displayName = 'PExclamationCircleOutlined';
export default React.forwardRef(PExclamationCircleOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PExclamationCircleOutlined.js
// module id = 3359
// module chunks = 0